import { useState } from "react";
import { SERVICE_GRID } from "../../../../../constants/serviceGrid";
import CustomInput from "../../../components/CustomInput";
import { formatCurrency } from "../../utils/money";
import EditButton from "./EditButton";

const AdditionalFeeRow = ({
  service,
  customPricing,
  editingAdditionalFeeNameId,
  setEditingAdditionalFeeNameId,
  editingAdditionalFeePriceId,
  setEditingAdditionalFeePriceId,
  updateAdditionalFeeName,
  updateAdditionalFeePrice,
  updateAdditionalFeeQuantity,
  updateAdditionalFeeVat,
  onRemove,
}) => {
  const [editingQuantity, setEditingQuantity] = useState(false);
  const [editingVat, setEditingVat] = useState(false);
  const price =
    service?.additionalFeePrice !== undefined
      ? Number(service?.additionalFeePrice)
      : Number(service?.additionalFee) || 0;
  const qty =
    service?.additionalFeeQuantity !== undefined ? Number(service?.additionalFeeQuantity) : 1;
  const subtotal = price * qty;
  const vat = Number(service.additionalFeeVat) || 0;
  const vatAmount = Math.round((subtotal * vat) / 100);

  return (
    <div
      className={`grid ${SERVICE_GRID} items-center border-t border-gray-100 bg-amber-50/30 px-4 py-3 text-sm`}
    >
      <div className="col-start-1 row-start-1" />
      <div className="col-start-2 row-start-1 flex justify-center text-center">
        {!customPricing || editingAdditionalFeeNameId !== service.id ? (
          <div className="flex items-center gap-2">
            <span className="font-medium italic text-gray-700">
              {service?.additionalFeeName || "Phí bổ sung"}
            </span>
            {customPricing && (
              <EditButton
                onClick={() => setEditingAdditionalFeeNameId(service.id)}
                ariaLabel="Sửa tên phí bổ sung"
              />
            )}
          </div>
        ) : (
          <CustomInput
            type="text"
            value={service?.additionalFeeName || "Phí bổ sung"}
            onChange={(value) => updateAdditionalFeeName(service.id, value)}
            height="34px"
            autoFocus
            onBlur={() => setEditingAdditionalFeeNameId(null)}
            onKeyDown={(event) => event.key === "Enter" && setEditingAdditionalFeeNameId(null)}
          />
        )}
      </div>

      <div className="col-start-3 row-start-1 flex items-center justify-center gap-1">
        {customPricing && editingQuantity ? (
          <CustomInput
            type="number"
            value={String(qty)}
            onChange={(value) =>
              updateAdditionalFeeQuantity(service.id, value)
            }
            height="36px"
            classNames="text-center"
            autoFocus
            onBlur={() => setEditingQuantity(false)}
            onKeyDown={(event) => {
              if (event.key === "Enter") setEditingQuantity(false);
            }}
          />
        ) : (
          <>
            <span>{qty}</span>
            {customPricing && (
              <EditButton
                onClick={() => setEditingQuantity(true)}
                ariaLabel="Sửa số lượng phí bổ sung"
              />
            )}
          </>
        )}
      </div>

      <div className="col-start-5 row-start-1 text-center text-gray-400">{formatCurrency(0)}</div>

      <div className="col-start-4 row-start-1 flex items-center justify-center gap-2">
        {!customPricing || editingAdditionalFeePriceId !== service.id ? (
          <>
            <span className="font-semibold text-amber-700">{formatCurrency(price)}</span>
            {customPricing && (
              <EditButton
                onClick={() => setEditingAdditionalFeePriceId(service.id)}
                ariaLabel="Sửa phí bổ sung"
              />
            )}
          </>
        ) : (
          <CustomInput
            type="number"
            value={String(price)}
            onChange={(value) => updateAdditionalFeePrice(service.id, value)}
            height="34px"
            autoFocus
            onBlur={() => setEditingAdditionalFeePriceId(null)}
            onKeyDown={(event) => event.key === "Enter" && setEditingAdditionalFeePriceId(null)}
          />
        )}
      </div>

      <div className="col-start-6 row-start-1 flex items-center justify-center">
        {customPricing && editingVat ? (
          <div className="w-[80%] max-w-[70px]">
          <CustomInput
            type="number"
            value={service.additionalFeeVat !== undefined ? service.additionalFeeVat.toString() : "10"}
            onChange={(value) => updateAdditionalFeeVat(service.id, value)}
            height="36px"
            classNames="text-center"
            placeholder="%"
            onBlur={() => {
              if (service.additionalFeeVat === "") updateAdditionalFeeVat(service.id, 0);
              setEditingVat(false);
            }}
          />
          </div>
        ) : (
          <div className="flex items-center justify-center gap-1">
            <span>{service.additionalFeeVat ?? 10}</span>
            {customPricing && (
              <EditButton
                onClick={() => setEditingVat(true)}
                ariaLabel="Sửa VAT phí bổ sung"
              />
            )}
          </div>
        )}
      </div>

      <div className="col-start-7 row-start-1 flex flex-col items-center text-center">
        <div className="font-semibold text-amber-700">{formatCurrency(subtotal + vatAmount)}</div>
        {vatAmount > 0 && (
          <div className="mt-0.5 text-[10px] text-amber-500">Thuế: {formatCurrency(vatAmount)}</div>
        )}
      </div>

      <button
        type="button"
        onClick={onRemove}
        aria-label="Bỏ phí bổ sung"
        title="Bỏ phí bổ sung"
        className="col-start-8 row-start-1 flex justify-center text-2xl leading-none text-red-500 hover:text-red-700"
      >
        x
      </button>
    </div>
  );
};

export default AdditionalFeeRow;
